/**
 * Tone mapping constants - extracted to break circular dependency
 * between sceneLights.ts and dynamicSkyMaterial.ts
 */
import * as THREE from "three";

export const TONE_MAPPING_ALGORITHM: THREE.ToneMapping = THREE.ACESFilmicToneMapping;

// We use a tweaked version of the ACES Filmic tonemapping curve.
export const HIGHARC_ACES_FILMIC_DIVISOR_A = "0.9837"; // original value: 0.9837
export const HIGHARC_ACES_FILMIC_DIVISOR_B = "0.43"; // original value: 0.43
export const HIGHARC_ACES_FILMIC_DIVISOR_C = "0.27"; // original value: 0.24
export const HIGHARC_ACES_FILMIC_ANTI_DARK_CRUNCH = "0.012"; // original value: 0.012

// debug/tonemapping-test is a good way to test these
export const TONEMAPPING_CYAN_HIGHLIGHTS_FACTOR = 0.96; // Setting this value higher will push highlights towards cyan
export const TONEMAPPING_PURPLE_HIGHLIGHTS_FACTOR = 1.0; // Setting this value higher will push highlights towards purple
export const TONEMAPPING_YELLOW_HIGHLIGHTS_FACTOR = 1.04; // Setting this value higher will push highlights towards yellow
